import { css } from '@emotion/react';

import { theme } from 'global';

export const usersTable = css`
  min-height: calc(100vh - 345px);
  max-height: calc(100vh - 345px);

  @media screen and (max-width: ${theme.breaks.lg - 1}px) {
    min-height: calc(100vh - 313px);
    max-height: calc(100vh - 313px);
  }

  @media screen and (max-width: ${theme.breaks.sm}px) {
    max-height: unset;
    min-height: unset;
  }
`;

export const pagination = css`
  display: flex;
  justify-content: center;
  margin-top: 24px;

  .MuiPaginationItem-root {
    color: ${theme.colors.primary.dark};

    &.MuiPaginationItem-outlinedPrimary.Mui-selected {
      font-weight: 500;
      color: ${theme.colors.primary.medium};
      border: 1px solid ${theme.colors.primary.medium};
      background-color: transparent;

      &:hover {
        background-color: rgba(0, 0, 0, 0.04);
      }
    }
  }
`;
